import { createPersistentStorage } from 'game/lib/persistentStorage';

interface Prefs {
  disableHelp: boolean,
  showColliders: boolean,
  skipIntro: boolean,
}

const initialValue: Prefs = {
  disableHelp: false,
  showColliders: false,
  skipIntro: false,
};

export const prefsStorage = createPersistentStorage(localStorage, initialValue, 'PREFS', 'v1');
